<section *ngIf="isLoading && !isLoaded">
  <nz-skeleton [nzActive]="true"
               [nzLoading]="isLoading"
               [nzTitle]="false"
               [nzParagraph]="{ rows: 2 }">
  </nz-skeleton>
</section>
<rappider-title-toolbar *ngIf="!isModalMode && (!isLoading || isLoaded)"
                        [mainTitle]="mainTitle"
                        [options]="title"
                        [displayToolbar]="displayToolbar"
                        [displayToolbarBackButton]="displayToolbarBackButton">
</rappider-title-toolbar>

<section>
  <rappider-spin [spinning]="!editingField">

    <rappider-crud-view-edit-form [config]="PROJECT_MODEL_DATA_FIELD_EDIT_CONFIG"
                                  [data]="editingField"
                                  [submitButtonLoading]="isFormLoading"
                                  (fieldValueChange)="onDataFieldValueChange($event)"
                                  (formSubmit)="onEditFieldSubmit($event)"></rappider-crud-view-edit-form>
  </rappider-spin>
</section>
